export enum UserRole {
  Broker = 'broker',
  Seller = 'seller',
  Admin = 'admin',
  SuperAdmin = 'superadmin'
}
